module.exports = __webpack_public_path__ + "img/20190531162331230.56dca6ee.png";